<template>
  <div id="app">
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
    <router-view/>
  </div>
</template>
<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application.
 */

import notice from './components/Notice.vue';

export default {
  /**
   * The name of the application.
   */
  name: 'NerzEx',

  components: {
    notice,
  },

  data() {
    return {
      isNotice: false,
      noticeTitle: '',
      noticeText: '',
      noticeType: '',
    }
  },

  /**
   * Fires when the app has been mounted.
   */
  mounted() {
    // If the user is authenticated,
    // fetch the data from the API
    if (this.$store.state.auth.authenticated) {
      this.$store.dispatch('account/find', JSON.parse(localStorage.getItem('nerzex.user')))
    }
  },
};
</script>
